import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
export function HeroSection() {
  return <SectionWrapper className="min-h-[80vh] flex items-center" data-id="element-68">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 items-center" data-id="element-69">
        <div className="flex flex-col space-y-8" data-id="element-70">
          <div data-id="element-71">
            <span className="text-xs font-medium tracking-[0.25em] uppercase text-text-secondary mb-5 block" data-id="element-72">
              NUEVO MÉTODO
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-[3.5rem] text-text leading-[1.15]" data-id="element-73">
              ¿Estás <strong className="font-bold" data-id="element-74">eligiendo</strong> cómo te
              sentís… o está{' '}
              <strong className="font-bold" data-id="element-75">decidiendo tu entorno</strong> por
              vos?
            </h1>
          </div>
          <p className="text-xl md:text-2xl text-text-secondary font-light leading-relaxed" data-id="element-76">
            No es falta de{' '}
            <strong className="font-semibold text-text" data-id="element-77">actitud</strong>. Es
            falta de{' '}
            <strong className="font-semibold text-text" data-id="element-78">regulación</strong>.
          </p>
          <p className="text-base text-text-secondary/80 leading-relaxed" data-id="element-79">
            Descubrí el{' '}
            <strong className="font-semibold text-text-secondary" data-id="element-80">
              Método ProMind Energy™
            </strong>{' '}
            de Regulación Energética Cotidiana.
          </p>
        </div>

        <div className="relative aspect-[3/4] w-full overflow-hidden" data-id="element-81">
          <img src="https://cdn.magicpatterns.com/uploads/4MGTJKJLLD5vzrKPzsM3uh/mujer_pensativa.jpg_2.png" alt="Mujer adulta en momento de reflexión" className="w-full h-full object-cover" data-id="element-82" />
        </div>
      </div>
    </SectionWrapper>;
}